import React, { useState, useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import axios from "axios";
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Slider } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ReactComponent as ChangeImageIcon } from '../../Assets/img/icons/change-image-icon.svg';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { useQuantityContext } from "../QuantityContext";

function FileDragUploadImage({ contextKey, accept, maxSize, inputId, stateOfData, setStateOfData }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const cropperRef = useRef(null);
    const [zoom, setZoom] = useState(100);

    const { handleInfo } = useQuantityContext();

    const maxSizeInBytes = maxSize * 1024 * 1024;
    // Function to handle file selection
    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const imageUrl = URL.createObjectURL(file);
        setSelectedFile(file);
        setSelectedImage(imageUrl);
        setOpenDialog(true);
    };

    // Function to handle cropping and saving the image
    const handleCropSave = () => {
        if (!cropperRef.current || !cropperRef.current.getCroppedCanvas) {
            console.error("Cropper not initialized or getCroppedCanvas function not available.");
            return;
        }

        const cropper = cropperRef.current;
        const canvas = cropper.getCroppedCanvas();

        if (canvas) {
            const offscreenCanvas = document.createElement('canvas');
            offscreenCanvas.width = canvas.width;
            offscreenCanvas.height = canvas.height;

            const ctx = offscreenCanvas.getContext('2d');
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
            ctx.drawImage(canvas, 0, 0);

            offscreenCanvas.toBlob(
                (blob) => {
                    const croppedFile = new File([blob], selectedFile.name || 'croppedImage.jpg', {
                        type: 'image/jpeg',
                    });

                    setSelectedImage(URL.createObjectURL(croppedFile));

                    const imageObject = {
                        name: croppedFile.name,
                        type: croppedFile.type,
                        data: URL.createObjectURL(croppedFile),
                    };

                    setStateOfData({ ...stateOfData, [contextKey]: imageObject.data });
                    setOpenDialog(false);
                    // handleFileUpload(croppedFile);
                },
                'image/jpeg'
            );
        } else {
            console.error("Canvas not available after cropping.");
        }
    };

    // Function to handle file upload to server
    const handleFileUpload = async (file) => {
        if (!file) {
            console.error('No file to upload.');
            return;
        }

        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const sasUrl = response.data.url;
            console.log("File uploaded successfully!", sasUrl);

            setStateOfData({ ...stateOfData, [contextKey]: sasUrl });
        } catch (error) {
            console.error('Error uploading file:', error.message);
            // alert('Error uploading file. Please check the console for details.');
            handleInfo('Error uploading file. Please check the console for details.');
        }
    };
    const validateAndUploadFile = (file) => {
        if (file && accept.includes(file.type)) {
            if (file.size <= maxSizeInBytes) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64format = reader.result;
                    const tempdata = base64format.split(",")[1];
                };
                handleFileUpload(file);
                reader.readAsDataURL(file);
            } else {
                // alert('Error uploading file. Please check the console for details.');
                handleInfo('Error uploading file. Please check the console for details.');
            }
        } else {
            // alert(`Invalid file type. Only ${accept.join(", ")} are allowed.`);
            handleInfo(`Invalid file type. Only ${accept.join(", ")} are allowed.`);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer.files[0];
        validateAndUploadFile(file);
    };

    //   const handleZoomChange = (event, newValue) => {
    //     setStateOfData({
    //       ...stateOfData,
    //       [contextKey]: {
    //         ...stateOfData?.[contextKey],
    //         zoom: newValue
    //       }
    //     });
    //   };

    const handleRemoveLogo = () => {
        setStateOfData({ ...stateOfData, [contextKey]: '' });
        // setLogo(null);
    };

    const handleCropperInitialized = (instance) => {
        cropperRef.current = instance;
    };

    return (
        <>
            <div className='w-100 h-100 add-logo-container text-center'
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}>
                <div className="file-upload-container p-0" style={{ height: "100%", width: "100%" }} onClick={() => document.getElementById(inputId).click()}
                // style={{ overflow: "hidden", minWidth: "230px", maxWidth: "230px" }}
                >
                    {stateOfData?.[contextKey] !== '' && stateOfData?.[contextKey] !== null ? (
                        <>
                            <img src={stateOfData?.[contextKey]} alt='Uploaded File' style={{ height: `${zoom}%`, width: `${zoom}%`, transition: 'width 0.2s', objectFit: "contain" }} />
                        </>
                    ) : (<>
                        <p className='mb-0 sub-heading-style '>Drag file here or </p>
                        {/* <div className='tertiary-text'> {maxSize / 1000} Kb Max File Size</div> */}
                        <IconButton color="inherit">
                            <AddCircleRoundedIcon />
                        </IconButton>
                    </>)}
                    <input id={inputId} type="file" accept={accept.join(",")} style={{ display: 'none' }} onChange={handleFileSelect} />
                </div>
                {/* {(stateOfData?.[contextKey] && stateOfData?.[contextKey] !== null) && (
                    <div className='image-controls' style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginTop: '10px' }}>
                        <IconButton color="inherit" onClick={() => document.getElementById(inputId).click()}>
                            <ChangeImageIcon />
                        </IconButton>
                        <IconButton color="inherit" onClick={handleRemoveLogo}>
                            <DeleteIcon />
                        </IconButton>
                    </div>
                )} */}
            </div>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Crop Image</DialogTitle>
                <DialogContent>
                    <div style={{ width: '100%', height: '400px', position: 'relative' }}>
                        <Cropper
                            ref={cropperRef}
                            src={selectedImage}
                            style={{ height: '100%', width: '100%' }}
                            initialAspectRatio={1}
                            guides={true}
                            cropBoxMovable={true}
                            cropBoxResizable={true}
                            crossOrigin="anonymous"
                            dragMode="crop"
                            viewMode={1}
                            background={false}
                            responsive={true}
                            autoCrop={false}
                            autoCropArea={1}
                            minCropBoxHeight={20}
                            minCropBoxWidth={20}
                            checkOrientation={false}
                            onInitialized={handleCropperInitialized}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCropSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default FileDragUploadImage;
